import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Box, Flex } from '@chakra-ui/react';
import { GlobalHeader } from '@sgi/gravity';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginRequestB2B, logoutRequestB2B } from '../../../..';
import { useEventBusListener } from '../../../../../shell/messaging/useEventBusListener';
import { GlobalEvents } from '../../../../types/events/globalEvents';
import AppUserMenu from './AppUserMenu';
export function AppHeader() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    const [shoppingCartShortcut, setShoppingCartShortcutData] = useState(null);
    useEventBusListener(GlobalEvents.updateShoppingCartShortcutEvent, (data) => {
        setShoppingCartShortcutData(data);
    }, { once: false });
    const onShoppingCartClick = () => {
        navigate('/shopping-cart');
    };
    return (_jsx(_Fragment, { children: _jsx(Flex, { w: "100%", flexGrow: 1, background: 'var(--sgi-colors-white)', borderBottom: '1px solid var(--sgi-colors-gray-100)', backdropFilter: 'blur(2px)', height: '60px', "data-testid": 'business-header-testid', children: _jsx(Box, { w: "100%", children: _jsx(GlobalHeader, { isSignedIn: isAuthenticated, onSignInClick: () => instance.loginRedirect({
                        ...loginRequestB2B(),
                        redirectStartPage: '/',
                    }), onSignOutClick: () => instance.logoutRedirect(logoutRequestB2B), userMenuItems: _jsx(AppUserMenu, {}), cartNotificationCount: shoppingCartShortcut?.numberOfItems, onCartButtonClick: onShoppingCartClick }) }) }) }));
}
